import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { ReactNode } from 'react'

export default function InfoCallout({ children }: { children: ReactNode }) {
    return (
        <>
            {/* Neutral, not primary: the reskin remapped primary to Arwen red,
                which turned every one of these into something that reads like an
                error. Red is severe's colour and yellow is WarningCallout's, so
                information is ink. */}
            <div
                className="flex items-center p-4 mb-4 text-sm text-ink-700 border border-ink-200 rounded-lg bg-ink-100"
                role="note"
            >
                <InformationCircleIcon
                    className="h-10 w-10 text-ink-500 pr-4"
                    aria-hidden="true"
                />
                <span className="sr-only">Info</span>
                <div>{children}</div>
            </div>
        </>
    )
}
